import ExpeditorStep from "./steps/ExpeditorStep";
import DestinatarStep from "./steps/DestinatarStep";
import ContractStep from "./steps/ContractStep";
import ReziliereStep from "./steps/ReziliereStep";
import PreviewStep from "./steps/PreviewStep";
import buildNotificareRezilierePDF from "./buildPDF";

const notificareReziliereConfig = {
  buildPDF: buildNotificareRezilierePDF,
  title: "Notificare de Reziliere Model 2026 (PDF)",
  subtitle: "Completeaza datele si genereaza o notificare de reziliere formala, gata de trimis",
  step1Benefit: "Reziliere corectă și fără litigii",
  pdfFilename: "notificare-reziliere-contract-inchiriere.pdf",
  downloadLabel: "Descarca Notificarea",
  steps: [
    { id: "expeditor", label: "Expeditor", title: "Cine Trimite Notificarea", icon: "\u{1F4E4}", component: ExpeditorStep },
    { id: "destinatar", label: "Destinatar", title: "Datele Destinatarului", icon: "\u{1F4E5}", component: DestinatarStep },
    { id: "contract", label: "Contract", title: "Datele Contractului", icon: "\u{1F4C4}", component: ContractStep },
    { id: "reziliere", label: "Reziliere", title: "Detalii Reziliere", icon: "\u{2702}\u{FE0F}", component: ReziliereStep },
    { id: "preview", label: "Preview", title: "Previzualizare Notificare", icon: "\u{1F4C4}", component: PreviewStep },
  ],
  defaultData: {
    expeditorEsteChirias: false,
    expeditorNume: "",
    expeditorCNP: "",
    expeditorCI: "",
    expeditorAdresa: "",
    destinatarNume: "",
    destinatarAdresa: "",
    contractNumar: "",
    contractData: "",
    contractAdresaImobil: "",
    motivReziliere: "",
    motivDetalii: "",
    preaviz: "",
    preavizCustom: "",
    dataIncetare: "",
    dataNotificare: "",
  },
  validate: (stepId, data) => {
    const errors = {};

    if (stepId === "expeditor") {
      if (!data.expeditorNume.trim()) {
        errors.expeditorNume = "Numele este obligatoriu";
      } else if (data.expeditorNume.trim().split(/\s+/).length < 2) {
        errors.expeditorNume = "Introduceti numele complet (nume si prenume)";
      }
      if (data.expeditorCNP.trim() && !/^\d{13}$/.test(data.expeditorCNP.trim())) {
        errors.expeditorCNP = "CNP-ul trebuie sa contina exact 13 cifre";
      }
      if (data.expeditorCI.trim() && !/^[A-Z]{2}\s?\d{6,7}$/i.test(data.expeditorCI.trim())) {
        errors.expeditorCI = "Format invalid (ex: RD 123456)";
      }
      if (!data.expeditorAdresa.trim()) errors.expeditorAdresa = "Adresa este obligatorie";
    }

    if (stepId === "destinatar") {
      if (!data.destinatarNume.trim()) {
        errors.destinatarNume = "Numele este obligatoriu";
      } else if (data.destinatarNume.trim().split(/\s+/).length < 2) {
        errors.destinatarNume = "Introduceti numele complet (nume si prenume)";
      }
      if (!data.destinatarAdresa.trim()) errors.destinatarAdresa = "Adresa este obligatorie";
    }

    if (stepId === "contract") {
      if (!data.contractData) errors.contractData = "Data semnarii este obligatorie";
      if (!data.contractAdresaImobil.trim()) errors.contractAdresaImobil = "Adresa imobilului este obligatorie";
    }

    if (stepId === "reziliere") {
      if (!data.motivReziliere) errors.motivReziliere = "Selecteaza motivul rezilierii";
      if (data.motivReziliere === "altele" && !data.motivDetalii.trim()) {
        errors.motivDetalii = "Descrie motivul rezilierii";
      }
      if (!data.preaviz) errors.preaviz = "Selecteaza termenul de preaviz";
      if (data.preaviz === "alt" && (!data.preavizCustom || Number(data.preavizCustom) <= 0)) {
        errors.preavizCustom = "Introdu un termen valid";
      }
      if (!data.dataIncetare) errors.dataIncetare = "Data incetarii este obligatorie";
      if (!data.dataNotificare) errors.dataNotificare = "Data notificarii este obligatorie";
    }

    return errors;
  },
};

export default notificareReziliereConfig;
